import * as types from './mutation-types';
import { getDefaultState } from './state';

export function getProductsCanAccessHash(products) {
    let hash = {};
    products.forEach(item => {
        hash[item.productCode] = item;
    });
    return hash;
}

export default {
    setIsGray: (state, val)=>{
        state.isGray= val;
    },
    [types.SET_USER_INFO]: (state, user) => {
        state.user = user;
    },
    [types.SET_PRODUCTS_CAN_ACCESS]: (state, products) => {
        state.productsCanAccess = products;
    },
    [types.SET_PRODUCTS_CAN_ACCESS_HASH]: (state, products) => {
        state.productsCanAccessHash = getProductsCanAccessHash(products);
    },
    [types.SET_CRT_PRODUCT]: (state, product) => {
        state.crtProduct = product;
    },
    [types.RESET_CRT_PRODUCT]: state => {
        state.crtProduct = getDefaultState().crtProduct;
    },
    [types.SET_USER_PRODUCT_PERMISSION]: (state, permissions = []) => {
    // TODO 这里把权限拍平的操作，统一到一个方法，和 shadow 中的重复了
        let permissionCodes = [];
        permissions.forEach(per => {
            if (per.selected) {
                permissionCodes.push(per.code);
            }
            per.children.forEach(subPer => {
                if (subPer.selected) {
                    permissionCodes.push(subPer.code);
                }
            });
        });
        state.permissions = permissionCodes;
    },
    [types.SET_SESSION_ID]: (state, sessionId = '') => {
        state.sessionId = sessionId;
    },
    [types.RESET]: state => {
        const defaultState = getDefaultState();
        Object.keys(defaultState).forEach(key => {
            if (key !== 'sessionId') {
                state[key] = defaultState[key];
            }
        });
    },
    [types.SET_PLUGINS_API_BASE_URL]: (state, url = '') => {
        state.pluginsApiBaseUrl = url;
    },
    [types.SET_IS_NEED_SECOND_AUTH]: (state, val = false) => {
        state.isNeedSecondAuth = val;
    },
    [types.SET_PLUGINS_PERMISSIONS]: (state, hash = {}) => {
        state.pluginPermissionsHash = hash;
    },
    [types.SET_WS_EXPORT_NUMBER]: (state, val) => {
        state.ws.exportNumber = val;
    },
    [types.SET_WS_EXPORT_INFO]: (state, val) => {
        state.ws.exportList = val;
    }
};
